<template lang="pug">
  b-row
    b-col
      b-form-group(label-cols="2" :label="label" label-align="left")
        b-input-group(:append="sufix")
          b-form-input(:id="id_custom+'_in'" :name="id_custom+'_in'" type='number' v-model="model_in")
          b-form-input(:id="id_custom+'_out'" :name="id_custom+'_out'" type='number' v-model="model_out")
</template>

<script>
  export default {
    name: "InputInOut",
    props: ['label','id_custom','type','description','sufix','model_in','model_out'],
    data(){
      return {
        inflow: "",
        outflow: ""
      }
    },
    computed:{

    }
  }
</script>

<style scoped>

</style>